import { Injectable } from '@angular/core';
import { TranslationService } from '@core/services/translation.service';
import { LogService } from '@yourcause/common/logging';
import { AttachYCState, BaseYCService } from '@yourcause/common/state';
import { MyInvitationsResources } from './my-invitations.resources';
import { MyInvitationsState } from './my-invitations.state';

@AttachYCState(MyInvitationsState)
@Injectable({ providedIn: 'root' })
export class MyInvitationsService extends BaseYCService<MyInvitationsState> {

  constructor (
    private myInvitationsResources: MyInvitationsResources,
    private logger: LogService,
    private translationService: TranslationService
  ) {
    super();
  }

  get myInvitations () {
    return this.get('myInvitations');
  }

  /**
   * Set My invitations
   */
  async setMyInvitations () {
    // If we haven't fetched them, proceed
    // If we have fetched them, only re-fetch if they actually have invitations
    // We refetch when they have invitations since the status could have changed
    if (!this.myInvitations || this.myInvitations.length > 0) {
      try {
        const result = await this.myInvitationsResources.getMyInvitations();
        const programTranslations = this.translationService.viewTranslations.Grant_Program;
        const cycleTranslations = this.translationService.viewTranslations.Grant_Program_Cycle;
        const myInvitations = result.records.map((record) => {
          return {
            ...record,
            grantProgramName: programTranslations[record.grantProgramId]?.Name ??
              record.grantProgramName,
            grantProgramCycleName: cycleTranslations[record.grantProgramCycleId]?.Name ??
              record.grantProgramCycleName
          };
        });
        this.set('myInvitations', myInvitations);
      } catch (e) {
        this.logger.error(e);
        this.set('myInvitations', []);
      }
    }
  }
}
